// The task text a form prefills (Orders → Paperwork → Assign as task).
// form: a Paperwork-tab form { name, status, signer_name, signed_at } (older
// callers passed a signed order { filename, signer_name, signed_at }).
const STATE = { detected: "Blank — to be filled out", filled: "Filled — needs signature" };

export function paperworkTaskText(form, patientName) {
  const file = String(form?.filename || form?.name || "");
  const name = file.replace(/\.(pdf|png|jpe?g)$/i, "");
  const who = String(patientName || "").trim();
  const status = form?.status || "signed";
  const signedOn = form?.signed_at
    ? new Date(form.signed_at).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })
    : "";
  const state = status === "signed"
    ? [form?.signer_name ? `Signed by ${form.signer_name}` : "Signed", signedOn].filter(Boolean).join(" · ")
    : STATE[status] || STATE.detected;
  return {
    title: who ? `Order paperwork: ${name} — ${who}` : `Order paperwork: ${name}`,
    description: [
      who && `Patient: ${who}`,
      state,
      `File: ${file}`,
      "Open it from the task, or from the patient's Orders → 📄 Paperwork tab.",
    ].filter(Boolean).join("\n"),
  };
}
